module.exports = __webpack_public_path__ + "media/images/icons/file_check-64a3ce2f9ca443dcfebd3b0545bf017a.svg";